export const EVITAL_QUOTE_BASE_URL =
    process.env.REACT_APP_EVITAL_QUOTE_BASE_URL || "https://www.evitalrx.in/sales/view/";
